module.exports = __webpack_public_path__ + "img/2-3.a584e005.png";